import { Col, Row } from "antd";
import React from "react";
import CardRow from '../component/CardRow'
import Rank from "../component/Rank";
import ReaderRecommendList from '../component/ReaderRecommendList'

const App = () => {
    return (<>
        <Row justify={'center'}>
            <Col span={22}>
                <Row gutter={[0,20]}>
                    <Col span={24}/>
                    <Col span={24}>
                        <CardRow />
                    </Col>
                    <Col span={8}>
                        <Rank />
                    </Col>
                    <Col span={16}>
                        <ReaderRecommendList />
                    </Col>
                </Row>
            </Col>
        </Row>
    </>)
}

export default App